import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/webnode/app/eduline-web/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/webnode/app/eduline-web/src/styles/tailwind.css");
